
import { useState, useRef, useEffect } from 'react';
import Button from '../Button';
import CustomDropdown from './CustomDropdown';


const HorizontalScroll = ({ data }) => {
    const [selectedCategory, setSelectedCategory] = useState("Category");
    const [selectedProduct, setSelectedProduct] = useState("Product");
    const [selectedStatus, setSelectedStatus] = useState("Status");
    const [currentIndex, setCurrentIndex] = useState(0);
    const containerRef = useRef(null);

    const scrollTo = (index) => {
        const container = containerRef.current;
        const itemWidth = container.scrollWidth / data.length;
        container.scrollTo({
            left: itemWidth * index,
            behavior: 'smooth',
        });
        setCurrentIndex(index);
    };

    const scrollLeft = () => {
        if (currentIndex > 0) {
            scrollTo(currentIndex - 1);
        }
    };

    const scrollRight = () => {
        if (currentIndex < data.length - 1) {
            scrollTo(currentIndex + 1);
        }
    };

    useEffect(() => {
        const container = containerRef.current;
        const handleScroll = () => {
            const itemWidth = container.scrollWidth / data.length;
            const newIndex = Math.round(container.scrollLeft / itemWidth);
            setCurrentIndex(newIndex);
        };
        container.addEventListener('scroll', handleScroll);
        return () => {
            container.removeEventListener('scroll', handleScroll);
        };
    }, []);
    const handleClick = (id) => {
        console.log('Clicked item ID:', id);
    };
   
        const payload = {
          category: selectedCategory !== "Category" ? selectedCategory : null,
          product: selectedProduct !== "Product" ? selectedProduct : null,
          status: selectedStatus !== "Status" ? selectedStatus : null,
        };
        console.log("Payload:", payload);
 
    return (
        <div className="relative w-full flex flex-col gap-6">
            <div className="flex justify-between  space-x-2">
                <div className="flex items-center gap-2">
                    sort by:
        
          <CustomDropdown
            options={['Category 1', 'Category 2', 'Category 3']}
            selected={selectedCategory}
            onSelect={(category) => setSelectedCategory(category)}
          />

          <CustomDropdown
            options={['Product 1', 'Product 2', 'Product 3']}
            selected={selectedProduct}
            onSelect={(product) => setSelectedProduct(product)}
          />
          <CustomDropdown
            options={['Pending', 'Confirmed', 'Cancelled']}
            selected={selectedStatus}
            onSelect={(status) => setSelectedStatus(status)}
          />
                </div>
                <div className="flex items-center gap-4">
                    <button
                        onClick={scrollLeft}
                        className={`px-2 py-1  rounded-md border-none border-secondary ${currentIndex === 0 ? "bg-[#FFD60057]" : "bg-primary"}`}
                        disabled={currentIndex === 0}
                        aria-label="Scroll left"
                    >
                        &#8592;

                    </button>
                    <button
                        onClick={scrollRight}
                        className="px-2 py-1 bg-primary rounded-lg border-none border-secondary"
                        disabled={currentIndex === data.length - 1}
                        aria-label="Scroll right"
                    >
                        &#8594;
                    </button>
                </div>
            </div>
            <div className="flex flex-col  gap-4">
                <div
                    className="overflow-x-scroll scrollbar-hide flex space-x-4 w-full"
                    ref={containerRef}
                >
                    {data.map((item, index) => (
                        <div
                            key={index}
                            className="min-w-[289px] bg-[#ffff] border-[2px] border-gray-300 flex flex-col gap-2  p-4 rounded-[10px]"
                        >
                            <div className='flex gap-2 items-center  '>
                                <img src={item.img} alt="event-image" className='w-[87px] h-[86px] rounded-[4px]' />
                                <div className='flex gap-4 flex-col'>
                                    <h2 className='text-[14px] leading-[18px] font-ManropeBold'>{item.name}</h2>
                                    <p className='text-[#666666] text-[12px] font-ManropeLight '>{item.question} Questions
                                    </p>
                                </div>
                            </div>
                            <div className='w-full flex justify-end'>
                                <div className=' w-fit'>
                                    <Button onClick={()=> handleClick(item.id)} >
                                        Take Test
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

        </div>
    );
};

export default HorizontalScroll;
